module.exports = __webpack_public_path__ + "img/step-10.3af19856.jpg";